import mock from './mock'


// JWT
import './jwt'

// Table

// Apps
import './data/apps/calendar'
import './data/apps/user'
import './data/apps/email'
import './data/apps/invoice'
import './data/apps/chat'
import './data/apps/eCommerce'

// dashboard
import './data/dashboard/analytics'
import './data/dashboard/ecommerce'

// pages
import './data/pages/faq-data'
import './data/pages/account-setting'
import './data/pages/profile-data'

//main
import './data/main/mainOther'
import './data/main/mainPool'
import './data/main/poolList'
import './data/main/farmsList'
import './data/main/farmsDetails'
import './data/main/farmsRounds'
import './data/main/farmsPartials'
import './data/main/farmsTransactions'
import './data/main/homePool'

mock.onAny().passThrough() // forwards the matched request over network
